export const getFailedTransferCutoffIso = () =>
  new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString();

/** ToBeVerified 48+ hrs in status (or missing updated-at). Matches Manage Tickets fail-to-transfer card. */
export const isFailToTransferTicketLike = (
  status: string | null | undefined,
  updatedAt: string | null | undefined,
  cutoffIso = getFailedTransferCutoffIso(),
): boolean => {
  if ((status || '') !== 'ToBeVerified') return false;

  const cutoffTs = Date.parse(cutoffIso);
  if (!Number.isFinite(cutoffTs)) return false;

  const updatedAtTs = Date.parse(updatedAt || '');
  if (!Number.isFinite(updatedAtTs)) {
    // Keep rows with missing timestamps for operational visibility.
    return true;
  }
  return updatedAtTs <= cutoffTs;
};

export type FailToTransferManageTicket = {
  tp_status?: string | null;
  tp_updated_at?: string | null;
};

export const isFailToTransferTicket = (
  ticket: FailToTransferManageTicket,
  cutoffIso = getFailedTransferCutoffIso(),
): boolean => isFailToTransferTicketLike(ticket.tp_status, ticket.tp_updated_at, cutoffIso);
